import { render, staticRenderFns } from "./k-switch.vue?vue&type=template&id=5cbde878&"
import script from "./k-switch.vue?vue&type=script&lang=js&"
export * from "./k-switch.vue?vue&type=script&lang=js&"
import style0 from "./k-switch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports